import React, {useState} from 'react'
import { createGlobalStyle } from 'styled-components';
import { Modal } from 'react-bootstrap';
import BaseBtn from '../common/styled/BaseBtn'
import BtnGroup from "../model/sub/BtnGroup"
import SuccessModel from "../model/SuccessModel"
import PropTypes from 'prop-types'
import {useAntiFraudStakingExist} from '../../hooks'

const GlobalStyle = createGlobalStyle`
  .noticeModel {
    font-size: 20px;
    .modal-dialog {
      max-width: 560px;
      .close {
        padding: 20px;
      }
    }
    .modal-title {
      color: #333;
      font-size: 20px;
    }
    .notice {
      color: #FF4540;
      text-align: left;
      font-size: 16px;
      margin-bottom: 15px;
      >a {
        margin-left: 100px;
        text-decoration: underline;
      }
    }
  }
`

export default function NoticeModel(props) {
  const [showMeta, setshowMeta] = useState(false)
  const isStaked = useAntiFraudStakingExist()

  const toStake = ()=> {
    if (window.ethereum) {
      props.onHide();
      props.toSupportModel();
    } else {
      setshowMeta(true);
    }
  }

  return (
    <>
      <SuccessModel
        show={showMeta}
        onHide={()=>{
          setshowMeta(false)
        }}
      >Please install a Metamask extension on the browser(PC) and link it first.</SuccessModel>
      <GlobalStyle />
      <Modal show={props.show}
        className="noticeModel"
        onHide={props.onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title> 
              Before filling out the form, please stake TRIAS first.
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="notice">
          *Please use Google Chrome(PC) with the extension of Metamask, or you can't stake TRIAS successfully.
            <a target="_blank" rel="noreferrer" href="https://docs.google.com/document/d/1Q5yIAmgkKgwbyx0xZsB0r0mmnah8LS8YTV797GYgI6Q/edit?usp=sharing">guidance</a>
          </p>
          <BtnGroup>
            {isStaked ?
              <a target="_blank" rel="noreferrer" href="https://forms.gle/jYU6pCvjGAwAgLw86" >
                <BaseBtn width="320px" heigth="42px">Staked. Submit the information form</BaseBtn>
              </a>
              : <BaseBtn onClick={toStake} width="150px" heigth="42px">stake</BaseBtn>
            }
          </BtnGroup>
        </Modal.Body>
      </Modal>
    </>
  )
}

NoticeModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}
